import { EmitEvent, EmitData, TrakerData } from './type';
import { getBasicInfo } from './utils';

import evtBus, { emitEvtBus, Events, type EventBus } from '~/hook/useEvtBus';

export type TrackerEvent = EventBus[Events.TRACKER];

class Tracker {
  constructor() {
    evtBus.init(Events.TRACKER, (data) => {
      this.on(data);
    });
  }

  private checkData(data: TrakerData[]) {
    const ds = JSON.stringify(data);

    let t = '';
    try {
      t = btoa(
        encodeURIComponent(ds).replace(/%([0-9A-F]{2})/g, function (e, t) {
          // @ts-ignore
          return String.fromCharCode('0x' + t);
        })
      );
    } catch {
      t = ds;
    }
    return encodeURIComponent(t);
  }

  private on(evt: TrackerEvent) {
    const { resolve, data } = evt;
    console.log('handleTracker', data);

    const formData = `data_list=${this.checkData(data)}`;
    fetch(import.meta.env.VITE_TRACKPOINT_URL, {
      method: 'POST',
      body: formData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((res) => {
      resolve(res);
    });
  }

  emit(data: EmitData[]) {
    const trakerData: TrakerData[] = data.map((item) => ({
      ...getBasicInfo(),
      ...item,
    }));

    return new Promise((resolve) => {
      emitEvtBus(Events.TRACKER, {
        data: trakerData,
        resolve,
      });
    });
  }
}

const tracker = new Tracker();

export { EmitEvent, type EmitData, type TrakerData };
export default tracker;
